function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7.676 7.676",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#c0c0c0",
      stroke: "none",
      strokeWidth: 0.175758,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill"
    },
    cx: 15.211,
    cy: 10.576,
    r: 3.838,
    transform: "translate(-11.373 -6.738)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2);
export default __webpack_public_path__ + "static/media/c2.f78c06f67d2623eb2800fda69cc5f8b4.svg";
export { ForwardRef as ReactComponent };